/**
 * tdw 上报
 * @author jero
 * @date 2016-11-03
 */
import util from '../lib/util';

// 基础配置，全局唯一
// url 链接不要随意添加其他域名，避免影响到小程序
var conf = {
    url: '//tmapp.qq.com/cgi-bin/activity_platform/tdw/report',
    timer: 300,
    beforeRequest: function() {}, // 请求发送之前
    success: function() {}, // 上报成功，即 ret === 0 时
    error: function() {}, // 上报失败，即 ret !== 0
    fail: function() {}, // 请求失败，请求没到达服务器
    // localPrefix: 'tdw_seq_',
    slicer: 5, // 异步过程中，如果数据量过大，请求参数就会过长，这个时候应该分片上报，默认 5 个/片
    table: '', // tdw 接口参数之一
    pr_ip: '', // ip 字段， tdw 接口参数之一
    pr_t: '' // 时间戳， tdw 接口参数之一
};
var commonData = {}; // 数据字段配置，全局唯一，每一条上报都应该带上这里面的数据

// field 基础池，至始至终只有一个池子，随着调用的增多，字段会逐步增多
//  单次上报中空缺的字段用空字符串补齐
var fieldMap = {};
var fieldArr = [];

var timer = 0; // 始终只有一个计时器

var _con = console || {}; // 用于上报log，等有插件可用后，可干掉

var DEFAULT_LEN_LIMIT = 50;
var URL_LEN_LIMIT = 450;
var LONG_FIELD = ['url', 'refer', 'courseid', 'ver1'];
// 数据基础池
// 异步上报过程中，所有的未处理的原始数据都要存到这里
var Pool = {
    pool: [],
    write: function(data) {
        if (util.isPlainObject(data)) {
            this.pool.push(data);
        } else if (Array.isArray(data)) {
            Array.prototype.push.apply(this.pool, data);
        }
    },
    read: function() {
        var ret = this.pool;
        this.pool = [];

        return ret;
    }
};

export default {
    config: function(data, config) {
        Object.assign(commonData, data);
        Object.assign(conf, config);

        parseField(commonData);
    },

    /**
     * 默认延迟上报
     *  因为数据可能合并，不给与修改 table, timer 等配置的机会，只得用公共配置
     * @param data
     */
    report: function(data) {
        // data = $.extend({}, commonData, data); // 不得污染全局的数据配置
        // request(composer(data));
        Pool.write(data);

        if (!timer) {
            timer = setTimeout(function() {
                toSlice();
                timer = 0;
            }, conf.timer);
        }
    },

    /**
     * 立即上报
     *  一次上报，可以修改配置
     * @param data
     * @param config
     */
    reportSync: function(data, config) {
        config = Object.assign({}, conf, config); // 不得污染全局的配置
        request(composer(data), config);
    },

    composer: composer,
    request: request,
    getCommonData: function(k) {
        return k ? commonData[k] : commonData;
    },
    getConfigData: function(k) {
        return k ? conf[k] : conf;
    }
};

/**
 * 组装表头和数据
 * @param data
 * @returns {{fields: Array, datas: Array}}
 */
function composer(data) {
    // var fields = [];
    var datas;

    parseField(data);
    datas = parseData(data);

    return {
        fields: fieldArr,
        datas: datas
    };
}

/**
 * 处理数据，除特殊数据外，默认其他字段长度不超过20
 * @param {*} data
 */
function processData(fields, data) {
    data = data || [];
    data.forEach(function (d) {
        d.forEach(function (v, index) {
            if (typeof v === 'string') {
                if (~LONG_FIELD.indexOf(fields[index])) {
                    d[index] = v.substring(0, URL_LEN_LIMIT);
                } else {
                    d[index] = v.substring(0, DEFAULT_LEN_LIMIT);
                }
            } else {
                d[index] = v;
            }
        });
    });
    return data;
}
/**
 * 处理表头
 * @param data
 */
function parseField(data) {
    if (!data) {
        return;
    }

    if (util.isPlainObject(data)) {
        data = [data];
    }

    if (!Array.isArray(data)) {
        return;
    }

    util.each(data, function (i, item) {
        util.each(item, function (k) {
            if (!fieldMap[k]) {
                fieldMap[k] = 1;
                fieldArr.push(k);
            }
        });
    });
}

/**
 * 处理数据
 * @param data
 * @returns {Array}
 */
function parseData(data) {
    var ret = [];
    var retItem;

    if (!data) {
        return;
    }

    if (util.isPlainObject(data)) {
        data = [data];
    }

    if (!Array.isArray(data)) {
        return;
    }

    util.each(data, function (i, item) {
        retItem = [];
        item = Object.assign({}, commonData, item); // 合并公共的
        util.each(fieldArr, function (i, field) {
            var v = item[field];
            v = v === undefined ? '' : v;
            retItem.push(v);
        });
        ret.push(retItem);
    });

    return ret;
}

/**
 * 发送请求，默认使用 jsonp ，暂不支持图片
 * @param fieldAndData
 * @param config
 */
function request(fieldAndData, config) {
    var param = {};

    config = config || conf;
    // param = $.extend({}, config);


    // 需要传到后台的参数
    util.each(['table', 'pr_ip', 'pr_t'], function (i, k) {
        param[k] = config[k] || '';
    });

    fieldAndData.datas = processData(fieldAndData.fields, fieldAndData.datas);
    param.fields = JSON.stringify(fieldAndData.fields);
    param.datas = JSON.stringify(fieldAndData.datas);
    // param.t = Math.random();
    // param.callback = '?';
    param.retype = 2; // jsonp 请求

    // console.log(param);
    // (new Image()).src = (config.url.indexOf('?') > 0 ? '&' : '?') + $.param(param);

    if (conf.beforeRequest(fieldAndData) === false) {
        return;
    }

    if (config.url) {

        util.loadJSONP(config.url, param, function(response) {
            conf[response.ret === 0 ? 'success' : 'error'](response, fieldAndData);
        });

        // $.ajax({
        //     url: config.url,
        //     data: param,
        //     dataType: 'jsonp'
        // })
        // .done(function(response) {
        //     conf[response.ret === 0 ? 'success' : 'error'](response, fieldAndData);
        // })
        // .fail(function(jqXHR, textStatus, errorThrown) {
        //     conf.fail(fieldAndData, jqXHR, textStatus, errorThrown);
        // });

        showConsole(fieldAndData.fields, fieldAndData.datas);
    }
}

/**
 * 数据条数过多的话，分片上报
 */
function toSlice() {
    var piece = [];

    var data = Pool.read();

    if (data.length <= conf.slicer) {
        request(composer(data));
    } else {
        util.each(data, function (i, item) {
            piece.push(item);

            if (i > 0 && i % conf.slicer === conf.slicer - 1) {
                request(composer(piece));
                piece = [];
            }
        });

        // 余下不够 conf.slicer 长度，也要上报
        if (piece.length) {
            request(composer(piece));
        }
    }
}

/**
 * 用于上报log，等有插件可用后，可干掉
 */
function showConsole(keyArr, valArr) {
    if (!_con.table || !window.localStorage) {
        return;
    }

    // 据vien说，直接访问localStorage会导致badjs
    try {
        if (
            parseInt(window.localStorage.getItem('tdwFlag'), 10) === 1 ||
            parseInt(window.localStorage.getItem('tdwFlag2'), 10) === 1
        ) {
            for (var i = 0, len = valArr.length; i < len; i++) {
                var obj = {};
                for (var j = 0, len2 = keyArr.length; j < len2; j++) {
                    if (valArr[i][j] !== '') {
                        obj[keyArr[j]] = valArr[i][j];
                    }
                }
                _con.table([obj]);
            }
        }
    } catch (e) {
        // Local访问出问题了，大不了看不了上报log了，不管了
    }
}
